import { render, staticRenderFns } from "./FNews.vue?vue&type=template&id=058e0e72"
import script from "./FNews.vue?vue&type=script&lang=js"
export * from "./FNews.vue?vue&type=script&lang=js"
import style0 from "./FNews.vue?vue&type=style&index=0&id=058e0e72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports